import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  BiContextProvidedValue,
  BiData,
  DefaultBiEvent,
} from '@wix/da-bi/pkg/events';
import PremiumDownloadIcon from '@wix/da-ds/pkg/Icons/24x24/PremiumDownload';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  /** don't display language after stat count */
  onlyNumbers?: boolean;
}

const PremiumDownloadStat: React.FC<Props> = ({
  deviation,
  onlyNumbers,
  className,
}) => {
  const { premiumDownloads } = useDeviationStats(deviation);
  // don't display 0 downloads
  const isShown = !!premiumDownloads;

  return isShown ? (
    <Stat
      className={className}
      deviation={deviation}
      icon={PremiumDownloadIcon}
      statNameLocaleKey="deviation.stats.premiumDownloads"
      statCount={premiumDownloads}
      onlyNumbers={onlyNumbers}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'premiumDownloads',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
    />
  ) : null;
};
PremiumDownloadStat.displayName = 'PremiumDownloadStat';
export default PremiumDownloadStat;
